import React from 'react';
import { useSelector } from 'react-redux';

import { Leaderboard, PrizeInfo } from '@swf/casino';
import Counter from '@swf/components/Counter/Counter';
import BaseModal from '@swf/components/StarsModal/BaseModal';
import CloseButton, { Variant } from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import { Size } from '@swf/core/models/modal';
import { select } from '@swf/core/store';
import type { CasinoRace } from '@swf/core/types/CasinoRaces';
import { isLeaderboard } from '@swf/core/utils/casino';

import Race from '../Race/Race';

import styles from './LeaderboardModal.scss';

interface Props {
  race: CasinoRace;
  leaderboard?: CasinoRace['leaderboard'];
  widgetId?: string;
  path?: string;
  onClose(): void;
}

const LeaderboardModal: React.FC<Props> = ({ race, onClose, leaderboard, widgetId, path }) => {
  const { name, status } = race;
  const standings = leaderboard || race.leaderboard || [];
  const modalPath = useSelector(select.modal.getCurrent);

  return (
    <BaseModal isOpen={!modalPath} size={Size.LARGE} onRequestClose={onClose} closeOnOverlayClick>
      <div className={styles.leaderboard}>
        <Header className={styles.header}>
          {name}
          <CloseButton variant={Variant.Light} onClick={onClose} />
        </Header>
        <div className={styles.raceContainer}>
          <Counter>
            {(count) => (
              <Race
                count={count}
                race={race}
                onLaunch={onClose}
                widgetId={widgetId}
                path={`${path}`}
              />
            )}
          </Counter>
        </div>
        <PrizeInfo prizeDetails={race.prizeDetails} legacyWidget />
        <Leaderboard
          race={race}
          className={styles.table}
          leaderboard={isLeaderboard(status)}
          standings={standings}
          legacyWidget
        />
      </div>
    </BaseModal>
  );
};

export default LeaderboardModal;
